import React from 'react';

import { FooterRowSkeleton } from '@sharedComponents/Skeletons';
import { StyledCheckoutWrapper } from '@styles/generalStyles';
import { ReactFCV } from '@types';

import { ReservationProductSkeleton } from './components/ReservationProductSkeleton';
import { StyledReservationTitleSkeleton } from './styled';

export const ReservationPageSkeleton: ReactFCV = () => {
  return (
    <StyledCheckoutWrapper data-testid="reservation-page-skeleton-wrapper">
      <StyledReservationTitleSkeleton data-testid="reservation-page-skeleton-title" />
      <ReservationProductSkeleton />
      <FooterRowSkeleton data-testid="reservation-page-skeleton-footer" />
    </StyledCheckoutWrapper>
  );
};
